import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@sb/library/button';
import { IconModule } from '@sb/library/icon';
import { DragAndDropItemComponent } from './drag-and-drop-item.component';
import { DragAndDropComponent } from './drag-and-drop.component';

@NgModule({
    declarations: [
        DragAndDropComponent,
        DragAndDropItemComponent
    ],
    imports: [
        DragDropModule,
        CommonModule,
        ButtonModule,
        IconModule
    ],
    exports: [
        DragAndDropComponent,
        DragAndDropItemComponent,
        DragDropModule
    ]
})
export class DragAndDropModule { }
